<c-container class="mt-5">
  <h2>Winner Payouts</h2>
  <app-winner-payouts [gameSetter]="{ gameP: activeGame, isCrossGame: false }"></app-winner-payouts>
</c-container>
